import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gridSize as getGridSize } from '@atlaskit/theme/constants';
import { css } from '@emotion/react';
var HEIGHT = 90;
export var genericErrorStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: ", "px;\n  margin: 0 auto ", "px;\n  display: block;\n"])), HEIGHT, getGridSize() * 3);